<template>
  <v-btn
    color="secondary"
    fixed
    fab
    dark
    bottom
    right
    small
    v-if="generarCatalogoBool"
    @click="generarCatalogoMetodo"
    :loading="loading"
  >
    <v-icon> mdi-shopping </v-icon>
  </v-btn>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      role: "auth/role",
    }),
    ...mapState({
      generarCatalogo: (state) => state.catalogos.generarCatalogo,
      negocioObjGest: (state) => state.app.negocioObjGest,
    }),
    loading: {
      get() {
        return this.$store.state.catalogos.loadingGenerarCatalogos;
      },
      set(v) {
        this.$store.commit("catalogos/setLoadingGenerarCatalogos", v);
      },
    },
    generarCatalogoBool() {
      return (
        false &&
        this.generarCatalogo &&
        !!this.negocioObjGest &&
        this.role == "admin"
      );
    },
  },
  methods: {
    generarCatalogoMetodo() {
      this.loading = true;
      this.$store
        .dispatch("catalogos/generarCatalogosPublicosFunctions")
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style>
</style>